import React, { useEffect, useMemo, useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import { sortElements } from '@BUP/utils/sortElements'
import BupSpinner from '@BUP/components/Loading/Spinner'
import QuestionsList from '@BUP/components/Sociogram/QuestionsList'
import { useCreateQuestionResponse } from '@BUP/hooks/Sociogram/useCreateQuestionReponse'
import { useSendParticpantsTerminated } from '@BUP/hooks/Sociogram/participantsTerminated/useSendParticpantsTerminated'
import { useTranslation } from 'react-i18next'

const SurveyQuestionsList = ({ enrollmentId, survey, page, nextPage }) => {
  const [t] = useTranslation()
  const history = useHistory()
  const { id: surveyId, companions, courses } = survey

  const sortedCompanions = useMemo(() => {
    return Array.isArray(companions) ? sortElements(companions) : []
  }, [companions])

  const {
    saveAllResponsesByPage,
    error: errorCreateResponse,
    dataResponse: dataCreateQuestionResponse,
    loadingResponse: loadingCreateQuestionResponse
  } = useCreateQuestionResponse(enrollmentId, surveyId)

  const {
    sendEnrollmentId,
    isLoading: loadingParticipantsTerminated,
    dataResponse: dataParticipantsTerminated,
    errorResponse: errorParticipantsTerminated
  } = useSendParticpantsTerminated()

  useEffect(() => {
    if (dataCreateQuestionResponse && !errorCreateResponse) {
      if (page === 6) {
        sendEnrollmentId({
          data: { enrollmentId, survey: surveyId }
        })
      } else {
        nextPage()
      }
    } else {
      history.push(`/sociogram/survey/${page}`)
    }
  }, [
    dataCreateQuestionResponse,
    errorCreateResponse,
    page,
    nextPage,
    enrollmentId,
    surveyId,
    sendEnrollmentId,
    history
  ])

  useEffect(() => {
    if (!errorParticipantsTerminated && dataParticipantsTerminated) {
      history.push('/sociogram/start-survey')
    }
  }, [errorParticipantsTerminated, dataParticipantsTerminated, history])

  const userEnrollmentWithCourses = useMemo(() => companions.find(
    classmate => classmate.enrollment === enrollmentId
  ), [companions, enrollmentId])

  const handleFormSubmit = useCallback(
    (responses) => {
      saveAllResponsesByPage(responses)
    },
    [saveAllResponsesByPage]
  )

  if (loadingCreateQuestionResponse || loadingParticipantsTerminated) {
    return (
      <BupSpinner
        size='large'
        tip={t('pages.data.answerSociogram.spinnerText')}
      />
    )
  }

  const userCourses = userEnrollmentWithCourses.courses
  const groupCoursesData = courses

  return (
    <QuestionsList
      classMates={sortedCompanions}
      onSubmit={handleFormSubmit}
      courses={userCourses}
      groupCoursesData={groupCoursesData}
      errorCreateResponse={errorCreateResponse}
      errorParticipantsTerminated={errorParticipantsTerminated}
      page={page}
      surveyId={surveyId}
    />
  )
}

export default SurveyQuestionsList
